import { z } from "zod";

const titleOkSchema = z.object({
	ok: z.literal(true),
	title: z.string().min(1).max(80),
});

const titleErrSchema = z.object({
	error: z.string(),
});

/**
 * Ask platform for a Claude-style Recents title (topic, not first-line echo).
 */
export async function requestChatTitle(input: {
	userMessage: string;
	assistantMessage?: string;
	signal?: AbortSignal;
}): Promise<{ ok: true; title: string } | { ok: false; error: string }> {
	const userMessage = input.userMessage.trim();
	if (!userMessage) return { ok: false, error: "empty_user_message" };

	try {
		const response = await fetch("/api/llm/title", {
			method: "POST",
			credentials: "include",
			signal: input.signal,
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				userMessage: userMessage.slice(0, 4_000),
				assistantMessage: input.assistantMessage?.trim().slice(0, 4_000),
			}),
		});
		const json: unknown = await response.json().catch(() => null);
		if (!response.ok) {
			const err = titleErrSchema.safeParse(json);
			return {
				ok: false,
				error: err.success ? err.data.error : `title_${response.status}`,
			};
		}
		const parsed = titleOkSchema.safeParse(json);
		if (!parsed.success) return { ok: false, error: "invalid_title_response" };
		return { ok: true, title: parsed.data.title };
	} catch (cause) {
		if (cause instanceof DOMException && cause.name === "AbortError") {
			return { ok: false, error: "aborted" };
		}
		return { ok: false, error: "title_network_error" };
	}
}
